import { render, staticRenderFns } from "./FiveSensesInput.vue?vue&type=template&id=14447665"
import script from "./FiveSensesInput.vue?vue&type=script&lang=js"
export * from "./FiveSensesInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports